import { Box } from "@mui/material";
import BackToTopButton from "components/BackToTopButton";
import ScrollToTop from "components/ScrollToTop";
import { Outlet, ScrollRestoration } from "react-router-dom";
import dayjs from "dayjs";
import "dayjs/locale/ja";
import { useEffect } from "react";
import AppFooter from "components/Footer";

function MainLayout() {
  useEffect(() => {
    dayjs.locale("ja");
  }, []);
  
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      bgcolor="#fff"
    >
      <ScrollToTop />
      <Outlet />
      <AppFooter />
      <BackToTopButton show={true} />
    </Box>
  );
}

export default MainLayout;
